import { useMediaQuery } from '@mui/material';

// These should match up to the breakpoints defined in /Themes/Mixins
export const SCREEN_XS: number = 0;
export const SCREEN_SM: number = 600;
export const SCREEN_MD: number = 900;
export const SCREEN_LG: number = 1200;
export const SCREEN_XL: number = 1500;

/**
 * Hook to determine if mobile layout should be used
 */
export const useIsMobile = () => {
    /**
     * Should line up to definition in /Themes/Mixins
     */
    return useMediaQuery(`(max-width: ${SCREEN_SM - 0.1}px)`);
};

/**
 * Hook to determine if tablet layout should be used
 */
export const useIsTablet = () => {
    /**
     * Should line up to definition in /Themes/Mixins
     */
    return useMediaQuery(`(max-width: ${SCREEN_MD - 0.1}px)`);
};

/**
 * Hook to determine if mobile landscape layout should be used
 */
export const useIsMobileLandscape = () => {
    /**
     * Should line up to definition in /Themes/Mixins
     */
    return useMediaQuery(`(max-height: ${SCREEN_SM}px) and (orientation: landscape)`);
};

/**
 * Hook to determine if tablet landscape layout should be used
 */
export const useIsTabletLandscape = () => {
    /**
     * Should line up to definition in /Themes/Mixins
     */
    return useMediaQuery(`(max-height: ${SCREEN_MD}px) and (orientation: landscape)`);
};